// src/pages/History.jsx
import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useHistoryApi } from '../api/history';
import Layout from '../components/Layout';

export default function History() {
  const { chatId } = useParams();
  const navigate = useNavigate();
  const { fetchHistoryList, fetchHistoryItem } = useHistoryApi();

  const [list, setList] = useState([]);
  const [entry, setEntry] = useState(null);

  // fetch the history list once on component mount
  useEffect(() => {
    let mounted = true;
    fetchHistoryList()
      .then(data => {
        if (mounted) setList(Array.isArray(data) ? data : []);
      })
      .catch(err => console.error('Error fetching history list:', err));
    return () => { mounted = false; };
  }, []);

  // fetch itinerary detail when chatId changes
  useEffect(() => {
    if (!chatId) {
      setEntry(null);
      return;
    }
    let mounted = true;
    fetchHistoryItem(chatId)
      .then(data => {
        if (mounted) setEntry(data);
      })
      .catch(err => console.error('Error fetching itinerary detail:', err));
    return () => { mounted = false; };
  }, [chatId]);

  const sidebarContent = (
    <div className="h-full flex flex-col">
      <h2 className="px-4 py-3 text-lg font-semibold border-b">
        Itinerary History
      </h2>
      <div className="flex-1 overflow-y-auto">
        {list.length > 0 ? (
          list.map(item => {
            const isActive = item.chatId === chatId;
            return (
              <div
                key={item.chatId}
                onClick={() => navigate(`/history/${item.chatId}`)}
                className={`px-4 py-3 cursor-pointer border-b last:border-0 ${
                  isActive ? 'bg-blue-100 font-medium' : 'hover:bg-gray-100'
                }`}
              >
                <div className="text-sm">{item.destination}</div>
                <div className="text-xs text-gray-500">
                  {new Date(item.createdAt).toLocaleString()}
                </div>
              </div>
            );
          })
        ) : (
          <div className="flex-1 flex items-center justify-center italic text-gray-400">
            No history available
          </div>
        )}
      </div>
    </div>
  );

  const mainContent = (
    <div className="p-6 flex-1 overflow-auto">
      {!entry ? (
        <p className="text-gray-500 text-lg">
          {chatId ? 'Loading itinerary details…' : 'Select an itinerary from the list.'}
        </p>
      ) : (
        <div className="space-y-4">
          <h1 className="text-2xl font-bold">{entry.destination}</h1>
          <p className="text-gray-500">
            {new Date(entry.createdAt).toLocaleString()}
          </p>
          <div className="bg-white p-4 rounded shadow prose max-w-none">
            {entry.response.split('\n').map((line, i) => (
              <p key={i}>{line}</p>
            ))}
          </div>
        </div>
      )}
    </div>
  );

  return (
    <Layout sidebar={sidebarContent}>
      {mainContent}
    </Layout>
  );
}
